<template>
  <section class="core-values-section">
    <div class="container">
      <div class="section-header">
        <h2>{{ content.header.title }}</h2>
        <p>{{ content.header.description }}</p>
      </div>

      <div class="values-grid">
        <div class="value-item" v-for="(value, index) in content.values" :key="index">
          <div class="value-icon">
            <i :class="value.icon"></i>
          </div>
          <h3>{{ value.title }}</h3>
          <p>{{ value.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TechItsCoreValuesComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Core Values Section */
.core-values-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.section-header p {
  font-size: 18px;
  color: #6c757d;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 50px;
}

.value-item {
  background: rgba(255, 255, 255, 0.05);
  padding: 40px 30px;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(246, 236, 79, 0.2);
}

.value-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: #f6ec4f;
}

.value-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f6ec4f, #f4d03f);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 32px;
  color: #2c3e50;
}

.value-item h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: "Archivo", sans-serif;
}

.value-item p {
  font-size: 16px;
  color: #6c757d;
  line-height: 1.6;
  margin: 0;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .core-values-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .core-values-section {
    padding: 60px 0;
  }
  
  .section-header h2 {
    font-size: 32px;
  }
  
  .values-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .value-item {
    padding: 30px 20px;
  }
  
  .value-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .value-item h3 {
    font-size: 20px;
  }
}

@media only screen and (max-width: 399px) {
  .core-values-section {
    padding: 40px 0;
  }
  
  .section-header h2 {
    font-size: 28px;
  }
}
</style>
